/* eslint-disable react/jsx-props-no-spreading */
import { getComponentFromName } from '../../lib/utils';

import * as GamesComponents from './gamesGroups/index';

interface GamesGroupProps {
    group: GamesGroup;
    [key: string]: any;
}

function GamesGroupItem({ group, ...props }: GamesGroupProps) {
    const { type } = group || {};
    const GamesGroupComponent = getComponentFromName(GamesComponents, type, 'default') || null;
    return GamesGroupComponent !== null ? <GamesGroupComponent group={group} {...props} /> : null;
}

export default GamesGroupItem;
